export default function SolutionsGrid() {
  const solutionsGrid = document.querySelectorAll<HTMLDivElement>(".js-solutions-grid");

  solutionsGrid.forEach((wrapper) => {
    const contentWrapper = wrapper.querySelector<HTMLDivElement>(".js-content-wrapper");
    const tabItemsHorizontal = wrapper.querySelectorAll<HTMLButtonElement>(".js-horizontal-tab-item");
    const tabItemsVertical = wrapper.querySelectorAll<HTMLButtonElement>(".js-vertical-tab-item");
    const panels = wrapper.querySelectorAll<HTMLDivElement>(".js-solutions-content-item");
    let activeIndex = 0;

    if (panels && panels.length > 0) {
      const handleContentHeight = () => {
        if (contentWrapper && panels[activeIndex]) {
          contentWrapper.style.height = `${panels[activeIndex].offsetHeight}px`;
        }
      };
      const handleActiveItem = () => {
        if (tabItemsVertical && tabItemsVertical.length > 0) {
          tabItemsVertical.forEach((tab, i) => {
            if (i === activeIndex) {
              tab.ariaSelected = "true";
            } else {
              tab.ariaSelected = "false";
            }
          });
        }
        if (tabItemsHorizontal && tabItemsHorizontal.length > 0) {
          tabItemsHorizontal.forEach((tab, i) => {
            if (i === activeIndex) {
              tab.ariaSelected = "true";
            } else {
              tab.ariaSelected = "false";
            }
          });
        }

        panels.forEach((item, i) => {
          let panelLink = item.querySelector('.panel-btn')
          if (i === activeIndex) {
            item.ariaHidden = "false";
            if(panelLink) {
              panelLink.classList.add('inline-flex')
              panelLink.classList.remove('hidden')
            }
          } else {
            item.ariaHidden = "true";
            if(panelLink) {
              panelLink.classList.add('hidden')
              panelLink.classList.remove('inline-flex')
            }
          }
        });
      };

      const handleClick = (index: number) => {
        activeIndex = index;
        handleActiveItem();
        handleContentHeight();
      };

      if (tabItemsVertical && tabItemsVertical.length > 0) {
        tabItemsVertical.forEach((tab, index) => {
          tab.addEventListener("click", () => handleClick(index));
        });
      }

      if (tabItemsHorizontal && tabItemsHorizontal.length > 0) {
        tabItemsHorizontal.forEach((tab, index) => {
          tab.addEventListener("click", () => handleClick(index));
        });
      }

      handleContentHeight(); // handle init height
      window.addEventListener("resize", handleContentHeight);
    }
  });
}
